import api from "./api";

// FBPM redesign-heuristics catalog (Ch.8 / Appendix A) — read-only reference.

/**
 * The 29 redesign heuristics, optionally filtered.
 * @param {{category?: string, dimension?: "TIME"|"COST"|"QUALITY"|"FLEXIBILITY"}} opts
 */
export async function getRedesignHeuristics(opts = {}) {
  const params = {};
  if (opts.category) params.category = opts.category;
  if (opts.dimension) params.dimension = opts.dimension;
  return api.get(`/redesign-heuristics`, { params });
}
